'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.ScheduleChange.WizardStep', dependencies).directive('rmWizardStep', require('./directives/WizardStepDirective'));